var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe-v4-layout',{attrs:{"id":"v4-supplier-ads-approvals-table","url":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }